import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { clsx } from 'clsx';
import * as React from 'react';
/**
 * SplitView - horizontal split layout with an animated right pane.
 *
 * The left pane fills all available space. The right pane slides in from the
 * right when `rightOpen` is true. When `resizable` is true a drag handle
 * appears between the panes so the user can adjust the right pane width.
 */
export function SplitView({ left, right, rightOpen = false, rightWidth: defaultRightWidth = 300, resizable = false, minRightWidth = 200, maxRightWidth = 600, className, leftClassName, rightClassName, }) {
    const [width, setWidth] = React.useState(defaultRightWidth);
    const [isDragging, setIsDragging] = React.useState(false);
    const dragRef = React.useRef(null);
    const handleMouseDown = React.useCallback((e) => {
        e.preventDefault();
        dragRef.current = { startX: e.clientX, startWidth: width };
        setIsDragging(true);
    }, [width]);
    React.useEffect(() => {
        if (!isDragging)
            return;
        const onMouseMove = (e) => {
            if (!dragRef.current)
                return;
            // Dragging the handle left expands the right pane
            const delta = dragRef.current.startX - e.clientX;
            const clamped = Math.max(minRightWidth, Math.min(maxRightWidth, dragRef.current.startWidth + delta));
            setWidth(clamped);
        };
        const onMouseUp = () => {
            dragRef.current = null;
            setIsDragging(false);
        };
        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', onMouseUp);
        return () => {
            window.removeEventListener('mousemove', onMouseMove);
            window.removeEventListener('mouseup', onMouseUp);
        };
    }, [isDragging, minRightWidth, maxRightWidth]);
    return (_jsxs("div", { className: clsx('split-view', rightOpen && 'split-view--open', resizable && 'split-view--resizable', isDragging && 'split-view--dragging', className), children: [_jsx("div", { className: clsx('split-view__left', leftClassName), children: left }), resizable && (_jsx("div", { className: "split-view__handle", role: "separator", "aria-orientation": "vertical", "aria-hidden": !rightOpen, onMouseDown: rightOpen ? handleMouseDown : undefined })), _jsx("div", { className: clsx('split-view__right', rightClassName), style: { ['--sv-right-w']: `${width}px` }, "aria-hidden": !rightOpen, children: right })] }));
}
//# sourceMappingURL=SplitView.js.map